function Loading() {
  return (
    <div className="  box_size_loader ">
      <div className="newLoadermain  flex  justify-center items-center">
        <div className="newLoader w-full ">
          <figure className="w-full text-center">
            <img
              src="/images/loaderr.gif"
              className="inline-block w-[40px] h-[40px]"
              alt=""
            />
          </figure>
          <h5 className="block text-sm text-gray-500 w-full text-center mt-1">
            Loading..
          </h5>
        </div>
      </div>
    </div>
  );
}

export default Loading;
